import * as z from "zod";

export const getProductTypes = {
  name: "getProductTypes" as const,
  input: z.object({}),
  output: z.array(z.string()),
};
